// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__DCsUD","loader":"Loader_loader__WEzse","rotation":"Loader_rotation__AzlIA"};